module.exports = __webpack_public_path__ + "static/media/comment_white.8d5bf5e8.svg";